<template>
  <div class="config-wrapper" v-if="configurator !== null">
    <div class="config-left">
      <lightgallery v-if="imgs.length > 0" :key="componentKey">
          <a v-for="(item, index) in imgs"
          :key="index"
            data-lg-size="1406-1390"
            class="gallery-item"
            :data-src="item"
          >
            <img
              class="img-responsive"
              :src="item"
            />
          </a>
     </lightgallery>
     <div v-else>
      <div v-if="checkHtmlLang == 'en'">
        Images are loading...
      </div>
      <div v-else>
        Afbeeldingen worden geladen...
      </div>
     </div>
    </div>
    <div class="config-right">
      <h1>{{title}}</h1>
      <div class="config-options" v-if="configurator !== null && configurator.option_groups.length > 0">
        <div v-for="group in configurator.option_groups" :key="group.optiongroup_name">
          <component
    v-if="group.options.length > 0"
    @option-selected="handleOptionSelected"
    :is="getComponent(group.optiongroup_type)"
    :name="getLocalizedOptionGroupName(group)"
    :slug="group.optiongroup_slug"
    :options="group.options"
    :selectedValue="requestObject[group.optiongroup_slug]"
  ></component>
        </div>
      </div>

      <div class="config-resume" v-if="configurator.option_groups.length > 0" :data-config-category="configurator.category_slug">
        <div class="mobile-top-wrapper">
          <div class="col-mobile-50">
          <h4><b>{{itemNumber}}</b></h4>
        <div class="usp-wrapper" v-html="getLocalizedCategoryDescription()"></div>

        </div>
        <div class="col-mobile-50-hidden">
          <img src="https://wixor.com/wp-content/uploads/2024/07/Tuv-zonder-achtergrond-normaal.png" alt="Main Image">
        </div>
        </div>
      
      
        <div class="info-wrapper">
          <div class="col-left">
            <div class="col-inner-left">
              <div class="config-img"></div>
              <div class="col-inner-meta-wrapper">
                <b>{{specLabel1.value}}</b>
                <small>{{ specLabel1.name }}</small>
              </div>
            </div>
            <div class="col-inner-right">
              <div class="config-img"></div>
              <div class="col-inner-meta-wrapper">
                <b>{{specLabel2.value}}</b>
                <small>{{ specLabel2.name }}</small>
              </div>
            </div>
          </div>
          <div class="col-right">
            <img src="https://wixor.com/wp-content/uploads/2024/07/Tuv-zonder-achtergrond-normaal.png" alt="Main Image">
          </div>
        </div>
      </div>
      <div v-else>
        <i>Geen opties gevonden voor de configurator....</i>
      </div>
  </div>
  </div>
  <div v-else>
    <div v-if="checkHtmlLang == 'en'">
        Configurator are loading...
      </div>
      <div v-else>
        Configurator wordt ingeladen...
      </div>
  </div>
</template>

<script>
import axios from 'axios';
import SliderComponent from './components/SliderComponent.vue';
import TileOption from './components/TileOption.vue';
import SkuSliderComponent from './components/SkuSliderComponent.vue';
import Lightgallery from 'lightgallery/vue/LightGalleryVue.umd.js';



export default {
  name: 'App',
  components: {
    SliderComponent,
    SkuSliderComponent,
    TileOption,
    Lightgallery
  },

  data() {
    return {
      componentKey: 0, // For initializing
      slug: '', // 
      itemNumber: '', // itemNumber of selected option
      frameWidthVal: '', 
      workingHeightVal: '',
      platformLengthVal: '',
      configurator: null,
      specs: null,
      dimensions: null,
      requestObject:{},
      specLabel1: {
        name: '',
        value: ''
      },
      specLabel2: {
        name: '',
          value: ''
      },
      imgs: [], // List of images
    };
  },
  mounted() {
    // Set the title
    this.title = window.appSettings.title;

    // Fetch all possible options by slug
    this.fetchOptions(window.appSettings.slug);

  },
  watch: {
    'configurator.category_slug': function() {
      this.updateSpecLabels();
    },
  },
  created() {
    this.checkHtmlLang();
    this.updateSpecLabels();
  },
  methods: {getLocalizedCategoryDescription() {
      if (this.configurator === null) {
        return ''; // Return an empty string if configurator is null
      }
      
      const lang = this.checkHtmlLang(); // Get the current language
      const descriptionKey = `category_description_${lang}`; // Construct the key for description
      return this.configurator[descriptionKey] || this.configurator.category_description; // Fallback to default description
    },
    getLocalizedOptionGroupName(group) {
      const lang = this.checkHtmlLang();
      const nameKey = `optiongroup_name_${lang}`; // Constructs the key based on current language
      return group[nameKey] || group.optiongroup_name; // Fallback to the default name
    },
    convertStringPropertiesToInt(requestObject, properties) {
  properties.forEach(property => {
    if (Object.prototype.hasOwnProperty.call(requestObject, property)) {
      const propertyValueStr = requestObject[property];
      const propertyValueInt = parseInt(propertyValueStr, 10);

      // Check if the conversion to integer was successful
      if (!isNaN(propertyValueInt)) {
        requestObject[property] = propertyValueInt;
      } else {
        console.warn(`${property} is not a valid number:`, propertyValueStr);
      }
    }
  });
    },
    forceRerender() {
      this.componentKey += 1;  
    },
    checkHtmlLang() {
      // Access the <html> element
      const htmlElement = document.documentElement;
      
      // Get the lang attribute
      const lang = htmlElement.getAttribute('lang');
      
      // Determine the return value based on the lang attribute
      let result;
      if (lang === 'nl') {
        result = 'nl';
      } else if (lang === 'de') {
        result = 'de';
      }  else if (lang === 'sl') {
        result = 'sl';
      } else {
        result = 'en';
      }
      
      return result;
    },
    updateSpecLabels() {
      const validSlugs = [
        'professioneel-2-delig',
        'professioneel-3-delig',
        'topsafe-2-delig',
        'topsafe-3-delig',
        'Smart-Level-met-Topsafe',
        'Multifunctioneel'
      ];

      if (this.configurator && validSlugs.includes(this.configurator.category_slug)) {
        if(this.checkHtmlLang() == 'nl'){
          this.specLabel1.name = 'Ingeschoven Lengte (m)';
          this.specLabel2.name = 'Uitgeschoven Lengte (m)';
        }

        if(this.checkHtmlLang() == 'en'){
          this.specLabel1.name = 'Retracted Length (m)';
          this.specLabel2.name = 'Extended Length (m)';
        }

        if(this.checkHtmlLang() == 'sl'){
          this.specLabel1.name = 'Zložena dolžina';
          this.specLabel2.name = 'Raztegnjena dolžina';
        }

        if(this.checkHtmlLang() == 'de'){
          this.specLabel1.name = 'Eingezogene Länge (m)';
          this.specLabel2.name = 'Ausgeschobene Länge (m)';
        }
     
      } else {

        if(this.checkHtmlLang() == 'nl'){
          this.specLabel1.name = 'Werkhoogte (m)';
          this.specLabel2.name = 'Platformhoogte (m)';
        }
        if(this.checkHtmlLang() == 'en'){
          this.specLabel1.name = 'Working height (m)';
          this.specLabel2.name = 'Platform height (m)';
        }
     
        // Set default values or handle other cases
        if(this.checkHtmlLang() == 'sl'){
          this.specLabel1.name = 'Delovna višina (m)';
          this.specLabel2.name = 'Višina platforme (m)';
        }

        if(this.checkHtmlLang() == 'de'){
          this.specLabel1.name = 'Retracted Length (m)';
          this.specLabel2.name = 'Extended Length (m)';
        } 
      }
    },
    getComponent(optionType) {
      const componentMapping = {
        '3': 'SkuSliderComponent',
        '2': 'SliderComponent',
        '1': 'TileOption'
      };
      return componentMapping[optionType] || 'div'; // Default to 'div' if no match found
    },
    setNewGallery(galleryString){
      this.imgs = [];
      this.imgs = galleryString.split(',').map(url => url.trim());
      this.forceRerender(); 
    },
    handleOptionSelected(index) {
      const validationObject = this.configurator.validation_object;

      // Variables to track the number of required fields
      let requiredFieldsCount = 0;

      // Process each item in the validation_object array
      validationObject.forEach(validationOption => {
        if (validationOption.required) {
          requiredFieldsCount++;
          if (validationOption.slug === index.slug && validationOption.regex !== '') {
            const regex = new RegExp(validationOption.regex);
            if (regex.test(index.option.option_value)) {
              this.requestObject[index.slug] = index.option.option_value;
            }
          }
        }
      });

      if (requiredFieldsCount === 1 && index.option.option_sku) {
        this.itemNumber = index.option.option_value;
        this.processOption(index.option, this.configurator.category_slug);
      } else if (requiredFieldsCount === 2) {
        console.log(this.requestObject);
        this.processOption(index.option, this.configurator.category_slug);
      }
    },
    async performScaffoldingInit() {
      try {
        // Await the completion of fetchScaffold
        await this.fetchScaffold(this.platformLengthVal, this.frameWidthVal, this.workingHeightVal);
       // await this.fetchScaffoldHeightList(this.itemNumber)
        await this.fetchVariableMeta(this.itemNumber);
        await this.fetchDimensions(this.itemNumber)
        
        // Call forceRerender
        this.forceRerender();
      } catch (error) {
        console.error("An error occurred:", error);
      }
    },
    async fetchOptions(slug) {
  try {
    const lang = this.checkHtmlLang();
    const url = `https://dv-wixor-steigro-api-896c757d25a1.herokuapp.com/config/optionsgroups/${slug}?lang=${lang}`;
    const response = await axios.get(url);

    this.configurator = response.data;
    const { option_groups } = this.configurator;
    const options = option_groups[0]?.options || [];

    // Set img URLs if index is found
    const index = options.find(option => option.option_value === this.itemNumber);
    if (index) {
      this.imgs = index.option_gallery.split(',').map(url => url.trim());
    }

    // Find and process selected option
    for (const group of option_groups) {
      const selectedOption = group.options.find(option => option.option_selected === true);
      if (selectedOption) {
        this.itemNumber = selectedOption.option_value;
        await this.processOption(selectedOption, this.configurator.category_slug);
        break;
      }
    }

    console.log('Vanuit init: ', this.requestObject);
  } catch (error) {
    console.error('Error fetching options:', error);
  }
    },
    async fetchHeightList(itemNumber) {
      try {
        const lang = this.checkHtmlLang();
        const response = await axios.get(`${window.appSettings.apiUrl}/height-list/${itemNumber}?lang=${lang}`);
        
        const contentDiv = document.getElementById('height-specs-new-wrapper');
        if (contentDiv) {
          contentDiv.innerHTML = response.data;
        }
      } catch (error) {
        console.error('Error fetching height list:', error);
      }
    },
    async fetchScaffoldHeightList(itemNumber) {
      try {
        const lang = this.checkHtmlLang();
        const response = await axios.get(`${window.appSettings.apiUrl}/height-list/scaffold/${itemNumber}?lang=${lang}`);
        
        const contentDiv = document.getElementById('height-specs-new-wrapper');
        if (contentDiv) {
          contentDiv.innerHTML = response.data;
        }
      } catch (error) {
        console.error('Error fetching height list:', error);
      }
    },
    async fetchScaffold(requestObject) {
  try {
    // Use axios.post to send requestObject in the body of the request
    const response = await axios.post(`${window.appSettings.apiUrl}/set`, requestObject);
    
    // Assuming response.data.itemNumber exists
    this.itemNumber = response.data.itemNumber;
  } catch (error) {
    console.error('Error fetching scaffold:', error);
    throw error; // Re-throw error to ensure it gets caught in performScaffoldingInit
  }
    },
    async fetchDimensions(itemNumber) {
      try {
        // Define valid slugs within the function
        const validSlugs = [
          'professioneel-2-delig',
          'professioneel-3-delig',
          'topsafe-2-delig',
          'topsafe-3-delig',
          'Smart-Level-met-Topsafe',
          'Multifunctioneel'
        ];
        const lang = this.checkHtmlLang();
        const response = await axios.get(`${window.appSettings.apiUrl}/dimensions/${itemNumber}?lang=${lang}`);
        
        // Basic labels
        this.specLabel1.value  = response.data.working_height;
        this.specLabel2.value  = response.data.platform_height;

        // Check if the category_slug is in validSlugs
        if (validSlugs.includes(this.configurator.category_slug)) {
          // Assign retracted_length to label1 and extended_length to label2
          this.specLabel1.value = response.data.retracted_length;
          this.specLabel2.value  = response.data.extended_length;
        }
      } catch (error) {
        console.error('Error fetching dimensions:', error);
      }
    },
    async fetchSpecs(itemNumber) {
      try {
        const lang = this.checkHtmlLang();

        const response = await axios.get(`${window.appSettings.apiUrl}/specs/${itemNumber}?lang=${lang}`);
        
        const contentDiv = document.getElementById('specs-new-wrapper');
        if (contentDiv) {
          contentDiv.innerHTML = response.data;
        }
      } catch (error) {
        console.error('Error fetching specs:', error);
      }
    },
    async fetchVariableMeta(itemNumber) {
      try {
        const response = await axios.get(`https://dv-wixor-steigro-api-896c757d25a1.herokuapp.com/config/options/meta/${itemNumber}`);
        this.imgs = response.data.gallery_image.split(',').map(url => url.trim());
      } catch (error) {
        console.error('Error fetching specs:', error);
        throw error; // Re-throw error to ensure it gets caught in performScaffoldingInit
      }
    },
    async  processOption(option, categorySlug) {
  const { option_value, option_sku, option_gallery, slug } = option;

  // Update requestObject
  this.requestObject[slug] = option_value;

  if (option_sku) {
    await Promise.all([
      this.fetchSpecs(option_value),
      this.fetchDimensions(option_value)
    ]);
    this.setNewGallery(option_gallery);
  }


  if (categorySlug === 'steiger-190' || categorySlug === 'steiger-250' || categorySlug === 'steiger-305') {
    const platformLength = parseInt(categorySlug.replace('steiger-', ''), 10);
    this.requestObject['platformlength'] = platformLength;
    this.convertStringPropertiesToInt(this.requestObject, ['platformlength', 'framewidth', 'workingheight']);
    await this.fetchScaffold(this.requestObject);
    await this.fetchSpecs(option_value);
    await this.fetchVariableMeta(option_value);
    await this.fetchDimensions(option_value);
    this.setNewGallery(option_gallery);
  }
    }
  }
};
</script>
